<template>
  <el-dialog title="操作日志" :visible.sync="dialogVisibleOperationLog" width="50%">
    <el-table
      ref="multipleTable"
      :data="operationLogTable"
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      height="500px"
      border>
      <el-table-column prop="createDate" label="操作时间">
        <template slot-scope="scope">{{scope.row.createDate|dateFilterL}}</template>
      </el-table-column>
      <el-table-column prop="createUser" label="操作人"></el-table-column>
      <el-table-column prop="result" label="日志" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="pageSize"
        :page-sizes="[30, 50, 100, 200]"
        :total="total"
      ></el-pagination>
    </div>
  </el-dialog>
</template>
<script>
import { pageQueryBySuidOperationLog } from '@/api/supplier/supplierManage'
import { formatDate } from '@/util/tool'
export default {

  data () {
    return {
      dialogVisibleOperationLog: false,
      operationLogTable: [],
      pageSize: 30,
      currentPage: 1,
      total: 0,
      suId: 0
    }
  },
  methods: {
    // 操作日志初始化
    onOperation (suId) {
      this.suId = suId
      this.dialogVisibleOperationLog = true
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 获取操作日志列表
    getList () {
      pageQueryBySuidOperationLog(this.currentPage, this.pageSize, this.suId)
        .then(res => {
          if (res.data.code === 200) {
            this.operationLogTable = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 分页页数
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.getList()
    },
    // 分页码数
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  },
  filters: {
    dateFilter
  }
}
function dateFilter (time) {
  const date = new Date(time)
  // eslint-disable-next-line no-undef
  return formatDate(date, 'yyyy-MM-dd')
}
</script>
<style lang="scss" scoped>
</style>
